"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_NAVIGATION_MENU_BACKDROP = exports.TOP_AREA_NAVIGATION_MENU = void 0;
const TOP_AREA_NAVIGATION_MENU = exports.TOP_AREA_NAVIGATION_MENU = 'top-area-navigation-menu';
const TOP_AREA_NAVIGATION_MENU_BACKDROP = exports.TOP_AREA_NAVIGATION_MENU_BACKDROP = 'top-area-navigation-menu-backdrop';
